const AppActions = {
  APP_MOUNTED: 'app/mounted',
  FETCH_TRANSLATIONS: 'translations/fetch',
};

export {
  AppActions,
};
